import React from "react";
import { DestinationTypeLabels } from "../../../models/destinationType.map";
import { canRetraiter } from "../model/suiviLivraisonRules";
import { TD, TH, destinationBlockHeaderStyle, destinationBlockStyle, photoButtonStyle, retraiterButtonStyle } from "../styles/suiviLivraisonStyles";
import { DestinationBadge, StatusPill } from "./SuiviBadges";
import { ActionTimeline, DestinationMedicationComments } from "./SuiviComments";

// Produits d'une commande patient pour un flux : statut, actions réalisées, bon signé et renvoi en production.

export function DestinationCommandeBlock({ destination, rows, busyId, onRetraiter, onViewPhoto }) {
    return (
        <section style={destinationBlockStyle}>
            <div style={destinationBlockHeaderStyle}>
                <DestinationBadge value={destination} />
                <span style={{ color: "#64748b", fontSize: "12px", fontWeight: 650 }}>
                    {rows.length} produit{rows.length > 1 ? "s" : ""}
                </span>
            </div>
            <DestinationMedicationComments destination={destination} rows={rows} />
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px", background: "white", tableLayout: "fixed" }}>
                <thead>
                    <tr>
                        <th style={{ ...TH, width: "36%" }}>Produit</th>
                        <th style={{ ...TH, width: "14%" }}>Statut</th>
                        <th style={{ ...TH, width: "32%" }}>Actions réalisées</th>
                        <th style={{ ...TH, textAlign: "right" }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map(row => (
                        <ProduitRow key={row.id} row={row} busyId={busyId} onRetraiter={onRetraiter} onViewPhoto={onViewPhoto} />
                    ))}
                </tbody>
            </table>
        </section>
    );
}

function ProduitRow({ row, busyId, onRetraiter, onViewPhoto }) {
    const busy = busyId === row.id;
    return (
        <tr style={{ background: "white" }}>
            <td style={{ ...TD, whiteSpace: "normal", wordBreak: "break-word" }}>
                <div style={{ fontWeight: 650, color: "#1e293b" }}>{row.nom}</div>
                <div style={{ color: "#94a3b8", fontSize: "11px" }}>
                    {[row.dosage, row.quantite ? `Qté ${row.quantite}` : null].filter(Boolean).join(" · ")}
                </div>
            </td>
            <td style={{ ...TD, whiteSpace: "normal" }}><StatusPill value={row.statut} /></td>
            <td style={{ ...TD, whiteSpace: "normal" }}><ActionTimeline row={row} /></td>
            <td style={{ ...TD, textAlign: "right", whiteSpace: "normal" }}>
                {row.signedBonAvailable && row.bonLivraisonHistoriqueId && (
                    <button onClick={() => onViewPhoto(row)} style={{ ...photoButtonStyle, marginRight: "6px" }}>
                        Voir le bon signé
                    </button>
                )}
                {canRetraiter(row) && (
                    <button onClick={() => onRetraiter(row)} disabled={busy} style={retraiterButtonStyle}>
                        {busy ? "En cours…" : `Renvoyer ${DestinationTypeLabels[row.destination] || ""}`}
                    </button>
                )}
            </td>
        </tr>
    );
}
